var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#262C2E",
    d: "M5 18a1 1 0 1 1 2 0 1 1 0 0 1-2 0M8 15a1 1 0 1 1 2 0 1 1 0 0 1-2 0M11 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M17 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0M14 9a1 1 0 1 1 2 0 1 1 0 0 1-2 0M17 18a1 1 0 1 1 2 0 1 1 0 0 1-2 0M14 15a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#262C2E",
    d: "M11 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M5 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0M8 9a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEx);
export default __webpack_public_path__ + "static/media/ex.5ee8fd9cca7255287484a6144653338b.svg";
export { ForwardRef as ReactComponent };